export class ReviewsPaginationDefaults {
  static readonly reviewsPageSize = 3;
  static readonly reviewsStartingPageNumber = 1;
}
